import { Button, Form, Input, Space } from 'antd';
import { FC } from 'react';

import { ButtonSuccess } from '@/common/components';
import { AppFormProps } from '@/common/interfaces';
import { defineInputStatus } from '@/common/utils';

import { ReferralFormFields, ReferralFormInputs } from '@/modules/Sites';

interface Props extends AppFormProps<typeof ReferralFormInputs, ReferralFormFields> {}

export const ReferralsFormView: FC<Props> = ({
  formName,
  formType,
  form,
  initialValues,
  formErrors,
  isFormLoading,
  validationSchema,
  handleBack,
  handleFinish,
  handleFinishFailed
}) => {
  return (
    <Form
      form={ form }
      layout="vertical"
      name={ formName }
      initialValues={ initialValues }
      disabled={ isFormLoading }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
    >
      <Form.Item hidden name={ ReferralFormInputs.SiteId }/>

      <Form.Item
        label="Назва"
        name={ ReferralFormInputs.Name }
        hasFeedback
        help={ formErrors?.name }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.name) }
        rules={ validationSchema.name }
      >
        <Input allowClear/>
      </Form.Item>

      <Form.Item
        label="Повний слаг"
        name={ ReferralFormInputs.Slug }
        hasFeedback
        validateStatus={
          defineInputStatus(
            isFormLoading,
            form.getFieldError(ReferralFormInputs.Slug).length || formErrors?.slug || formErrors?.extension
          )
        }
        rules={ validationSchema.slug }
        help={ formErrors?.slug }
        normalize={ (value) => value ? value.toLowerCase() : value }
      >
        <Input allowClear/>
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button type="default" onClick={ handleBack }>
            Скасувати
          </Button>
          <ButtonSuccess loading={ isFormLoading } type="primary" htmlType="submit">
            { formType === 'edit' ? 'Зберегти' : 'Створити' }
          </ButtonSuccess>
        </Space>
      </Form.Item>
    </Form>
  );
};
